import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import camelCase from 'lodash/camelCase';
import Button from './Button';
import Anchor from './Anchor';
import Headline6 from './Typography/Heading/Headline6';
import breakpoints from './Theme/breakpoints';
import { bottomRoundedCorners } from './RoundedCorners';

const StyledContainer = styled.div`
  && {
    height: 170px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    text-align: center;
  }
`;

const StyledButton = styled(Button)`
  && {
    margin-bottom: 0;
  }
`;

const StyledAnchor = styled(Anchor)`
  && {
    height: 150px;
    width: 100%;
  }
`;

const Container = styled.div`
  border: 1px solid var(--grey-light);
  padding: 48px 16px;

  @media(min-width: ${breakpoints.md}px) {
    padding: 32px 24px;
  }

  .fade-in {
    animation: fade-in 300ms both;
  }

  .fade-out {
    display: none;
  }

  /* stylelint-disable-next-line selector-type-no-unknown */
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    overflow: hidden;
  }
  ${bottomRoundedCorners};
`;

const LogoContainer = styled.div`
  max-width: 170px;
  position: relative;
  overflow: hidden;
`;

const JobTitle = styled(Headline6)`
  && {
    margin: 0;
     /* stylelint-disable-next-line value-no-vendor-prefix */
    display: -webkit-box;
    /* stylelint-disable-next-line value-no-vendor-prefix */
    -webkit-line-clamp: 2;
    /* autoprefixer: ignore next */
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-bottom: 4px;
  }
`;

class HighlightedJobs extends PureComponent {
  constructor() {
    super();

    this.state = {
      selectedIndex: 0,
    };
  }

  componentDidMount() {
    const { animate } = this.props;

    if (animate) {
      this.intervalId = setInterval(() => {
        const { jobs } = this.props;
        const jobCount = jobs.length;
        const randomIndex = Math.floor(Math.random() * jobCount);
        this.setState({
          selectedIndex: randomIndex,
        });
      }, 2000);
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  render() {
    const {
      jobs,
      locale,
      applyButtonText,
    } = this.props;
    const urlKey = camelCase(locale);

    const { selectedIndex } = this.state;

    return jobs.length > 0 && (
      <Container className="container">
        {jobs.map(({ job, logo }, index) => {
          const url = job.urls[urlKey];

          return (
            <div
              key={job.id}
              // eslint-disable-next-line max-len
              className={`fade-${index === selectedIndex ? 'in' : 'out'} container-item job-${job.id}`}
            >
              <StyledAnchor
                href={url}
                styled
                key={job.id}
              >
                <StyledContainer>
                  <JobTitle tag="h2">
                    {job.title}
                    {' - '}
                    {job.city}
                  </JobTitle>
                  <LogoContainer>
                    {logo}
                  </LogoContainer>
                  <StyledButton
                    className="homepage-highlighted-jobs"
                    role="link"
                  >
                    {applyButtonText}
                  </StyledButton>
                </StyledContainer>
              </StyledAnchor>
            </div>
          );
        })}
      </Container>
    );
  }
}

HighlightedJobs.defaultProps = {
  jobs: [],
  applyButtonText: undefined,
  locale: undefined,
  animate: true,
};

HighlightedJobs.propTypes = {
  /** It's the list of jobs */
  jobs: PropTypes.arrayOf(PropTypes.shape({})),
  /** It's the locale of jobs */
  locale: PropTypes.string,
  /** It's the text of apply button */
  applyButtonText: PropTypes.string,
  /** Animate multiple records */
  animate: PropTypes.bool,
};

export default HighlightedJobs;
